import React, {useState, useEffect, useContext} from 'react'
import { TextField, Autocomplete, Button } from '@mui/material';

import CustomerInfos from '../customerInfos/CustomerInfos';

import { FirebaseContext } from '../../Services/firebase'

export default function CustomerList(props) {

    const firebase = useContext(FirebaseContext)

    const [Customers, setCustomers] = useState([]);
    const [Infos, setInfos] = useState([]);
    const [value, setValue] = useState('clients');
    const [inputValue, setInputValue] = React.useState('');
    
    useEffect(() => {
        const getData = async () => { 
            const querySnapshot = await firebase.getCustomers(props.UserSession.uid).get();
            const customersList = querySnapshot.docs.map(doc => doc.data().name);
            setCustomers(customersList);
        }
        getData()
    }, [firebase, props.UserSession.uid])

    const getInfos = () => {
        setInfos([])
        firebase.getCustomerInfos(props.UserSession.uid, value).get()
        .then( doc => {
            const mydata = doc.data()
            setInfos(mydata)
        })
    }

  return (
      <div style={{display: "flex", flexDirection: "column"}}>
        <div style={{display: "flex", flexDirection: "row", marginBottom: "1vh"}}>
            <Autocomplete
                value={value}
                onChange={(event, newValue) => {
                    setValue(newValue);
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                disablePortal
                id="combo-box-demo"
                options={Customers}
                sx={{ width: 300 }}
                renderInput={(params) => <TextField {...params} label="clients" />}
            />
            <Button variant="outlined" style={{marginLeft: "0.5vw"}} onClick={getInfos}>Afficher</Button>
        </div>
        { Infos.length === 0 ? null :
            <CustomerInfos Infos={Infos} uid={props.UserSession.uid}/>
        }
    </div>

  );
}